/**
 * @generated SignedSource<<196bf09df166be6b8ca5ac80161d48ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpers_getPhotoImgProps_photo$data = {
  readonly masterOrZoomPath: string | null;
  readonly smallPath: string | null;
  readonly " $fragmentType": "helpers_getPhotoImgProps_photo";
};
export type helpers_getPhotoImgProps_photo$key = {
  readonly " $data"?: helpers_getPhotoImgProps_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpers_getPhotoImgProps_photo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpers_getPhotoImgProps_photo"
};

(node as any).hash = "92b72678b7172cac5b3ed320df6b3750";

export default node;
